import { QuestionUITypes, QuestionElement, QuestionBaseParams } from './question-base';
import { ButtonQuestion } from './question-button';
import { QuestionRow } from './question-row';

export class ModalButtonQuestion extends ButtonQuestion {
  public questionType = QuestionUITypes.MODALBUTTON;
}

export class ModalQuestion extends QuestionRow {
  public questionType = QuestionUITypes.MODAL;
  public modalId: string = "";
}





// WEBPACK FOOTER //
// ./src/app/question-modal.ts